<template>
  <AddArticle />
</template>
<script>
import appConfig from '@/app.config'
import AddArticle from '../../../components/dadban/articles/AddArticle.vue'
export default {
  page: {
    title: 'اضافه کردن مقاله',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'dadban-add-articles',
  components: {
    AddArticle,
  },
}
</script>
